/**
 * WeDev — alt_image_map gallery filtering (product.metafields.custom.alt_image_map).
 *
 * Extracted from wd-js-product-images so the main snippet stays smaller. This file runs the
 * "exact alt key" branch: build altMap from fetched section HTML, compute expectedAlt, then
 * filter slides/thumbs and re-init media.
 *
 * Dependencies (must exist when this runs — defined in wd-js-product-images.liquid, same page):
 *   - stampSlideAndThumbIndexes(container)
 *   - initializeProductMedia(container)
 *
 * Related storefront pieces:
 *   - Pillow fabric for "כרית גב" is a fake metafield option (wd-variant-fake-option, name^="fake_option"),
 *     not a Shopify variant option; we extend expectedAlt so data-alt keys like "כרית גב Natural אפור פחם" match.
 *
 * Load: layout/theme.liquid — same <script src="{{ asset }}" defer> pattern as theme.js, before wd-scripts.
 */
(function () {
  'use strict';

  /** Collapse whitespace for data-alt / thumbnail-alt keys (single definition for all comparisons). */
  function normAltKey(a) {
    return (a || '').replace(/\s+/g, ' ').trim();
  }

  /**
   * @param {HTMLElement} container — live [data-product-images] node on the page
   * @param {HTMLElement} newProductImages — parsed fragment from Section Rendering API fetch
   * @param {string[]} selectedOptions — option1..option3 values from variant / fallbacks (same order as main script)
   */
  function wdApplyAltImageMapGalleryFilter(container, newProductImages, selectedOptions) {
    if (!container || !newProductImages) return;

    var option3Wrap = document.querySelector('.variant-input-wrap[data-index="option3"]');
    var option3Value = null;
    if (option3Wrap) {
      var select = option3Wrap.querySelector('select');
      if (select) option3Value = select.value;
    }

    var altMap = {};
    newProductImages.querySelectorAll('.product-main-slide').forEach(function (slide) {
      var alt = slide.getAttribute('data-alt');
      var normalizedAlt = normAltKey(alt);
      if (normalizedAlt) {
        altMap[normalizedAlt] = (altMap[normalizedAlt] || 0) + 1;
      }
    });

    var selectedColor = (selectedOptions && selectedOptions[1]) || '';
    var normalizedOption3 = normAltKey(option3Value);
    var normalizedColor = normAltKey(selectedColor);

    var expectedAlt = '';
    if (normalizedColor && normalizedOption3) {
      expectedAlt = normAltKey(normalizedOption3 + ' ' + normalizedColor);
    } else if (normalizedColor) {
      expectedAlt = normAltKey(normalizedColor);
    }

    // --- "כרית גב" + fake pillow (see wd-variant-fake-option) ---
    var fakePillowInput = document.querySelector('input[name^="fake_option"]:checked');
    var pillowVal = fakePillowInput && fakePillowInput.value ? normAltKey(fakePillowInput.value) : '';
    var expectedAltPillowMiddle = '';
    if (pillowVal && normalizedOption3 === 'כרית גב' && normalizedColor) {
      expectedAlt = normAltKey(normalizedOption3 + ' ' + normalizedColor + ' ' + pillowVal);
      expectedAltPillowMiddle = normAltKey(normalizedOption3 + ' ' + pillowVal + ' ' + normalizedColor);
    }

    var matchingAlts = Object.keys(altMap).filter(function (alt) {
      if (alt === 'all') return true;
      if (alt === expectedAlt) return true;
      if (expectedAltPillowMiddle && alt === expectedAltPillowMiddle) return true;
      return false;
    });

    newProductImages.querySelectorAll('.product-main-slide').forEach(function (slide) {
      var altNorm = normAltKey(slide.getAttribute('data-alt'));
      if (!matchingAlts.includes(altNorm)) {
        slide.remove();
      }
    });

    container.innerHTML = newProductImages.innerHTML;

    var thumbsScroller = document.querySelector('.product__thumbs--scroller');
    if (thumbsScroller) {
      thumbsScroller.querySelectorAll('.product__thumb-item').forEach(function (thumbItem) {
        var thumbAlt = thumbItem.getAttribute('thumbnail-alt');
        var normalizedThumbAlt = normAltKey(thumbAlt);
        if (!matchingAlts.includes(normalizedThumbAlt)) {
          if (thumbItem.parentNode) thumbItem.parentNode.removeChild(thumbItem);
        }
      });
    }

    if (typeof stampSlideAndThumbIndexes === 'function') {
      stampSlideAndThumbIndexes(container);
    } else {
      console.warn('[wd] stampSlideAndThumbIndexes missing — ensure wd-js-product-images.liquid is loaded.');
    }
    if (typeof initializeProductMedia === 'function') {
      initializeProductMedia(container);
    } else {
      console.warn('[wd] initializeProductMedia missing — ensure wd-js-product-images.liquid is loaded.');
    }
  }

  window.wdApplyAltImageMapGalleryFilter = wdApplyAltImageMapGalleryFilter;
})();
